import styled from 'styled-components';
import { DesignTokens } from '@klarna/bubble-ui';
import { useGetToken } from '@klarna/mp-ui';
import { DropZone } from './DropZone';

export const Header = styled.div`
  display: flex;
  justify-content: start;
  width: 100%;
`;

export const TitleAndDescription = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;

  width: 100%;

  padding: 20px;

  border: 1px solid #e5e5e5;
  border-radius: 8px;
`;

export const UploadAreaLabel = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;

  height: 35%;
`;

export const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;

  width: 100%;
  height: 50px;

  border-radius: 8px;

  background: ${(props: { error?: unknown }) => (props.error ? '#ffedec' : 'none')};
  padding: 10px 15px 0px 15px;
`;

export const LoaderTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const CenteredRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const UploaderContainer = styled(DropZone)`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;

  width: 100%;
  height: 150px;

  background-color: ${() =>
    useGetToken<DesignTokens.Color>('colors/backgrounds/subtle-inline').toString()};
  border: 1px dashed #93969a;
  border-radius: 8px;
`;
